import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import DataTable from 'react-data-table-component';
import { getSalesOrderList, confirmOrDraftSalesOrder } from '../../../services/index';
import toast, { Toaster } from 'react-hot-toast';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import EditIcon from '@mui/icons-material/Edit';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Loader from '../../Common/Loader';
import { getFormattedNumber } from '../../utils/textUtils';
import { callPutAxios } from '../../../services/common/common';
import { SALE_ORDER_URL } from '../../../CONSTANTS';
import PaginationDataTable from '../../Common/PaginationDataTable';
import { Cookie } from '@mui/icons-material';
import Cookies from "universal-cookie";
// import { useLocation } from "react-router-dom";
const SalesList = (props) => {
    let navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(0);
    const location = useLocation();
    const [userData, setUserData] = useState("");
  
    const getSalesList = () => {
        let list_data = {
            page: 0,
            size: -1,
            search: '',
        };
        setLoading(true)
        getSalesOrderList(list_data).then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket.data;
                d.reverse();
                setData(d);
                setFilteredData(d);
                setLoading(false)
            } else {
                setLoading(false)
                toast.error(res.message);
            }
        }).catch(error => setLoading(false));
    };

    const handleSearch = (search) => {
        const result = data.filter((data) => {
            return (
                data.totalAmount?.toString().toLowerCase().includes(search.toLowerCase()) ||
                data.subTotalAmount?.toString().toLowerCase().includes(search.toLowerCase()) ||
                data.customerTitle.toLowerCase().includes(search.toLowerCase()) ||
                data.orderNo.toLowerCase().includes(search.toLowerCase()) ||
                data.salesOrderStatusEnum.toLowerCase().includes(search.toLowerCase()) ||
                data.salesOrderDate.toLowerCase().includes(search.toLowerCase())
            );
        });
        setFilteredData(result);
    };


    const handleClick = (row) => {
        const superAdmin = props.superAdmin;
        const isAfterConfirmPage = (props.urlList && props.urlList.has("/salesOrder/afterSalesOrderConfirm"));

        const isBeforeConfirmation = !row.isConfirmed;

        if (superAdmin || (isAfterConfirmPage && row.isConfirmed) || isBeforeConfirmation) {
        }
        navigate("/salesorders/" + row.recordId + "/edit");
    };

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                name: 'ORDER No.',
                selector: (data) => data.orderNo,
                style: { color: "#007bff", cursor: "pointer" }
            },
            {
                name: 'DATE',
                selector: (data) => data.salesOrderDate,
                style: { cursor: "pointer" }
            },
            {
                name: 'CUSTOMER NAME',
                selector: (data) => data.customerTitle,
                width: '300px',
                style: { cursor: "pointer" }
            },

            {
                name: 'INVOICED',
                style: { cursor: "pointer" },
                selector: (data) => (
                    <div className='text-center'>
                        {data.isCanceled ? <div>Cancelled</div> : data.isInvoiced ? (
                            <Tooltip title='Invoiced' arrow placement='top'>
                                <i id='ember591' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs text-fulfilled'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        ) : data.isConfirmed ? (
                            <ReceiptIcon style={{ cursor: 'pointer', align: 'right' }} onClick={() => navigate(`/invoices/new`, { state: { invoiceId: data.recordId, invoiceOrder: true } })} />
                        ) : (
                            'Not Confirmed'
                        )}
                    </div>
                ),
            },
            {
                name: 'PAYMENT',
                style: { cursor: "pointer" },
                selector: (data) => (
                    <div className='text-center'>
                        {data.isPaid ? (
                            <Tooltip title='Paid' arrow placement='top'>
                                <i id='ember591' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs text-fulfilled'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        ) : (
                            <Tooltip title='Not Paid' arrow placement='top'>
                                <i id='ember579' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs fill-empty'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                name: 'SHIPPED',
                style: { cursor: "pointer" },
                selector: (data) => (
                    <div className='text-center'>
                        {data.isShipped ? (
                            <Tooltip title='Shipped' arrow placement='top'>
                                <i id='ember591' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs text-fulfilled'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        ) : (
                            <Tooltip title='not Shipped' arrow placement='top'>
                                <i id='ember579' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs fill-empty'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                name: 'AMOUNT',
                style: { cursor: "pointer" },
                selector: (data) => getFormattedNumber(data.totalAmount),
            },
            {
                name: 'ACTION',
                style: { cursor: "pointer" },
                selector: (row) => (
                    <div>
                        {
                            !(row.isCanceled) && <>
                                {row.isShipped ? (
                                    <></>
                                ) : (
                                    // {userRole === "superadmin" && !orderConfirmedStatus && (
                                    //     <EditIcon
                                    //         style={{ fontSize: "15px", cursor: "pointer" }}
                                    //         onClick={() => handleClick(row)}
                                    //     />
                                    // )}
                                    <>
                                        {props.superAdmin || ((props.urlList.has("/salesOrder/afterSalesOrderConfirm") ||(props.urlList.has("/salesOrder/{uuid}") && !row.isConfirmed))) ? !row.isInvoiced ? (
                                            <EditIcon
                                                style={{ fontSize: "15px", cursor: "pointer" }}
                                                onClick={() => navigate("/salesorders/" + row.recordId + "/edit")}
                                            />
                                        ) : (
                                            <></>
                                        ) : <></>}
                                    </>
                                )}
                                &nbsp;&nbsp;
                                {row.isConfirmed || row.isInvoiced ? (
                                    <></>
                                ) : (
                                    <>
                                        <ThumbUpAltIcon
                                            style={{
                                                fontSize: '15px',
                                                cursor: 'pointer',
                                                color: 'greenyellow',
                                            }}
                                            onClick={() => handleConfirm(row.recordId)}
                                        />
                                        <HighlightOffIcon onClick={() => handleCancelOrder(row.recordId)} />
                                    </>
                                )}
                            </>
                        }
                    </div>
                ),
            }

        ],
        [handleRefresh]
    );

    const handleRowClick = (row) => {
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/salesorders/${recordId}`);
        }
    };

    const handleClickNew = () => {
        navigate('/salesorders/new');
    };

    const handleConfirm = (id) => {
        confirmOrDraftSalesOrder(id).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
                // getSalesList();
                handleRefresh();
            } else {
                toast(res.message);
            }
        });
    };

    const handleCancelOrder = async (id) => {
        const rUrl = SALE_ORDER_URL() + `cancelOrder/${id}`
        const rObj = {}
        const response = await callPutAxios(rUrl, rObj)
        if (response.errorCode === 0) {
            toast.success(response.message)
            // getSalesList()
            handleRefresh();
        } else {
            toast.error(response.message);
        }
    }
    return (
        <>
            <div className='page-container'>
                <div style={{ height: 500, width: '100%' }}>
                    {/* <DataTable
                        title='All Sales Orders'
                        columns={columns}
                        data={filteredData}
                        fixedHeader
                        pagination
                        pointerOnHover={true}
                        highlightOnHover={true}
                        onRowClicked={(data) => navigate(`/salesorders/${data.recordId}`)}
                        progressPending={loading}
                        progressComponent={<Loader />}
                        subHeader
                        subHeaderComponent={
                            <div className='d-flex align-items-center'>
                                <div className='input-group searchInput mr-2'>
                                    <div className='input-group-prepend'>
                                        <span className='input-group-text' id='basic-addon1'>
                                            <SearchRoundedIcon />
                                        </span>
                                    </div>
                                    <input autoComplete='off' className='form-control' type='text' placeholder='Search Here' onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                                // <Link to='/salesorders/new'>
                                //     <button id='ember5839' className='tooltip-container ember-view btn btn-primary d-flex align-items-center' type='button'>
                                //         <AddIcon />
                                //         New
                                //     </button>
                                // </Link>
                            </div>
                        }
                    /> */}

                    <PaginationDataTable
                        paginationUrl={
                            SALE_ORDER_URL() + "getAllRecords"
                        }
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        onRowClicked={handleRowClick}
                        onNewClicked={handleClickNew}
                    />
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default SalesList;
